import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector'

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    debug: true,
    fallbackLng:'en',
    resources: {
      en: {
        translation: {
          signIn: 'Sign in',
          signOut:'Sign out',
          talks:'Talks',
          events:'Events',
          gallery:'Gallery',
          loading:'Loading',
          email:'Email',
          password:'Password',
          forgotPassword: 'I forgot my password',
          wrongPassword: 'Wrong password',
          userNotFound: 'The user does not exist',
          unvalidEmail: 'The email is unvalid',
          accessAs: 'Access as',
          groups:'Groups',
          exhibitors:'Exhibitors',
          guests:'Guests',
          users:'Users',
          organizers:'Organizers',
          staff:'Staff',
          inviteClients:'Invite clients',
          seeAsExh: 'See as exhibitor',
          seeAsOrg: 'See as organizer',
          seeingAs: 'Seeing as',
          exhibitor:'Exhibitor',
          accept: 'Accept',
          phoneNumber: 'Phone number',
          position: 'Position',
          close: 'Close',
          form: 'Form',
          inscriptionFor: 'Inscription for',
          fullName:'Full name',
          company: 'Company',
          location: 'Location',
          fiscalId:'Fiscal ID',
          permissions: 'Permissions',
          consentText: 'You give consent for your contact information to be shared with the exhibitors of the event',
          requestMeeting: 'Request meeting',
          meetingInputTitle: 'Tell us if you want to coordinate an individual meeting with any of the following companies',
          meetingInputText: 'In which case, the company will contact you to coordinate the meeting during the event',
          specifyBrand: '(Optional) Specify brand',
          noEventFound: 'No event was found',
          weAreWaiting: 'We are waiting for you on',
          send: 'Send'
        }
      },
      es: {
        translation: {
          signIn: 'Iniciar sesión',
          signOut:'Cerrar sesión',
          talks:'Charlas',
          events:'Eventos',
          gallery:'Galería',
          loading:'Cargando',
          email:'Email',
          password: 'Contraseña',
          forgotPassword: 'Olvidé mi contraseña',
          wrongPassword: 'Contraseña incorrecta',
          userNotFound: 'El usuario no existe',
          unvalidEmail: 'El email es inválido',
          accessAs: 'Acceder como',
          groups:'Grupos',
          exhibitors:'Expositores',
          guests:'Asistentes',
          users:'Usuarios',
          organizers:'Organizadores',
          staff:'Staff',
          inviteClients:'Invitar clientes',
          seeAsExh: 'Ver como expositor',
          seeAsOrg: 'Ver como organizador',
          seeingAs: 'Viendo como',
          exhibitor:'Expositor',
          accept: 'Aceptar',
          phoneNumber: 'Número de teléfono',
          position: 'Cargo',
          close: 'Cerrar',
          form: 'Formulario',
          inscriptionFor: 'Inscripción para',
          fullName:'Nombre completo',
          company: 'Empresa',
          location: 'Localidad',
          fiscalId:'ID fiscal',
          permissions: 'Permisos',
          consentText: 'Usted da conformidad para que sus datos de contacto sean compartidos con los expositores del evento',
          requestMeeting: 'Solicitar reunión',
          meetingInputTitle: 'Indíquenos si quiere coordinar una reunión individual con alguna de estas empresas',
          meetingInputText: 'Es ese caso la empresa se contactará para coordinar el encuentro durante el evento',
          specifyBrand: '(Opcional) Especificar marca',
          noEventFound: 'No se ha encontrado el evento',
          weAreWaiting: 'Lo esperamos el',
          send: 'Enviar'
        }
      }
    }
  })